// extracted by mini-css-extract-plugin
export default {"namesAndPartiesView":"NamesAndParties-module_namesAndPartiesView__Rv4vT","twoCellField":"NamesAndParties-module_twoCellField__OjtDO"};